import { preventNonNumericInput, validateNumericValue } from '../../helpers/utils';
import MessageHelper from '../../helpers/message-helper';
import FacetQueryBuilder from '../../helpers/facet-query-builder';
import SnowChainsFacetFilter from './snow-chains-facet-filter';

const hasValidName = (_, element: HTMLInputElement | HTMLSelectElement): boolean => (element.name !== undefined && element.name.length > 0);

export default class FacetFilters {
  private readonly submit: JQuery;
  private readonly stockLevelInputField: JQuery;
  private readonly snowChainFacet?: SnowChainsFacetFilter;

  constructor(private readonly form: JQuery, isInitialOrder?: boolean) {
    this.submit = form.find('.js-submitFacetSearch');
    this.stockLevelInputField = form.find('.js-stockLevelInputField');
    const isAlternativeSearch = form.data('alternative-search') as boolean;
    const hasQuickSearchAvailable = form.data('quick-search-available') as boolean;

    const snowChainContainer = form.find('.js-snowChainsFacet');
    if (snowChainContainer.length) {
      this.snowChainFacet = new SnowChainsFacetFilter(snowChainContainer[0]);
    }

    if (!isInitialOrder && !isAlternativeSearch) {
      this.bindStockLevelInputChange();
    }

    if (hasQuickSearchAvailable) {
      const quickSearchField = this.form.find<HTMLInputElement>('#tireQuickSearch');
      const quickSearchGroup = this.form.find<HTMLSelectElement | HTMLInputElement>('input[data-group=quickSearch], select[data-group=quickSearch]');
      if (quickSearchGroup?.length > 0) {
      quickSearchGroup.on('change input', () => {
        quickSearchField[0].value = '';
      });
      }
    }

    this.bindSubmit();
  }

  private bindStockLevelInputChange(): void {
    this.stockLevelInputField.on('keypress', (e) => preventNonNumericInput(e as unknown as Event));

    this.stockLevelInputField.on('change', (e) => {
      const value = $(e.target)
        .val() as string;

      if (validateNumericValue(value) && (value.length <= 4)) {
        return;
      }

      e.preventDefault();
      const message = MessageHelper.getMessage('eparts.validation.tireNumberFormat');
      this.stockLevelInputField.val('');
      window.NotificationHelper.showError(message);
    });
  }

  private bindSubmit(): void {
    this.form[0]?.addEventListener('submit', (e) => {
      const queryBuilder = new FacetQueryBuilder();
      queryBuilder.resetFacetSearchQuery();

      const inputsNotCheckboxes = this.form.find<HTMLSelectElement | HTMLInputElement>('select, input:not([type=checkbox])');
      const checkboxes = this.form.find<HTMLInputElement>('input[type=checkbox]');

      inputsNotCheckboxes
        .filter(hasValidName)
        .each((i, el) => {
          const input = $(el);
          if (input.data('query-param')) {
            queryBuilder.setValueAsQueryParameter(input);
          } else {
            queryBuilder.setValueInFacetSearch(input);
          }
        });

      checkboxes
        .filter(hasValidName)
        .each((i, el) => {
          const checkbox = $(el);

          if (checkbox.data('query-param')) {
            if (checkbox.prop('checked')) {
              queryBuilder.setValueAsQueryParameter(checkbox);
            } else {
              queryBuilder.removeValueAsQueryParameter(checkbox);
            }
          } else if (checkbox.prop('checked')) {
            queryBuilder.setValueInFacetSearch(checkbox, true);
          }
        });

      queryBuilder.resetPaginationPageNumber();

      if (!e.defaultPrevented && this.form.parsley().isValid()) {
        e.preventDefault();
        const query = queryBuilder.getQuery();
        const formAction = this.form.attr('action');
        if (formAction !== undefined) {
          window.location.href = `${formAction}?${query}`;
        } else {
          window.location.search = query;
        }
      }
    });
  }
}
